// extracted by mini-css-extract-plugin
module.exports = {"filter-item-wrapper":"HouseType_filter-item-wrapper__qbYtP","filter-item-container":"HouseType_filter-item-container___cL2S"};